module.exports = __webpack_public_path__ + "img/finance_19.61cb748e.png";